import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './pages/index'
import { Provider } from 'react-redux'
import store from './store'
import UserService from './lib/userService'
import { Typography } from '@mui/material'

/**
 * render object
 */
const render = () => {
    const container = document.getElementById('root')
    const root = createRoot(container)
    root.render(<React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>)
}

/**
 * render object
 */
const renderError = (errorMSg) => {
    const container = document.getElementById('root')
    const root = createRoot(container)
    root.render(<React.StrictMode>
        <Provider store={store}>
            <Typography>Something went wrong {errorMSg}</Typography>
        </Provider>
    </React.StrictMode>)
}

UserService.initKeycloak(render, renderError)
// render()
